import { MemberEvents } from '@kudos/http-client'
import {
  getActivePublicMemberCelebration,
  isBeforeRangeEnd,
  isWithinRange,
} from '@shared/celebration/memberEvents'
import { format, getYear, parseISO } from 'date-fns'

export const shouldShowBirthdayRow = (events: MemberEvents | null | undefined): boolean =>
  !!(events && events.birthday !== null && events.birthdayPublic)

export type WorkRow = { kind: 'startDate' | 'anniversary'; date: string }

export const getWorkMilestoneRow = (
  events: MemberEvents | null | undefined,
  today: Date = new Date(),
): WorkRow | null => {
  if (!events) return null
  const todayKey = format(today, 'yyyy-MM-dd')
  const { welcome, welcomeRange, welcomePublic } = events
  if (welcome && isBeforeRangeEnd(todayKey, welcomeRange)) {
    if (welcomePublic) return { kind: 'startDate', date: welcome }
    if (isWithinRange(todayKey, welcomeRange)) return null
  }
  if (events.anniversaryPublic && events.anniversary) {
    return { kind: 'anniversary', date: events.anniversary }
  }
  return null
}

/** Whether a milestone is being celebrated today, gating the profile card's details block. */
export const hasActiveProfileMilestone = (
  events: MemberEvents | null | undefined,
  today: Date = new Date(),
): boolean => getActivePublicMemberCelebration(events, today) !== null

/** Whether `isoDate` lands in a later year than today, so the year needs spelling out. */
export const isFutureYear = (isoDate: string, today: Date = new Date()): boolean =>
  getYear(parseISO(isoDate)) > getYear(today)

export const formatProfileEventDate = (isoDate: string, showYear = false): string =>
  format(parseISO(isoDate), showYear ? 'MMMM d, yyyy' : 'MMMM d')
